import { render, staticRenderFns } from "./auto-form-group.vue?vue&type=template&id=ae796aba&scoped=true&"
import script from "./auto-form-group.ts?vue&type=script&lang=ts&"
export * from "./auto-form-group.ts?vue&type=script&lang=ts&"
import style0 from "./auto-form-group.scss?vue&type=style&index=0&id=ae796aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae796aba",
  null
  
)

export default component.exports